import { ExecutionStatus, StatusColorConfig } from "./playGroundTypes";

export const STATUS_COLOR_MAP: Record<ExecutionStatus, StatusColorConfig> = {
  [ExecutionStatus.PASSED]: { bgColor: "#E6F3F0", textColor: "#005D49" },
  [ExecutionStatus.FAILED]: { bgColor: "#FEE4E2", textColor: "#D92D20" },
  [ExecutionStatus.STOPPED]: { bgColor: "#FEE4E2", textColor: "#D92D20" },
  [ExecutionStatus.RUNNING]: { bgColor: "#d6e6ff", textColor: "#0041a3" },
  [ExecutionStatus.IDLE]: { bgColor: "#f5f5f5", textColor: "#6b7280" },
  [ExecutionStatus.SKIPPED]: { bgColor: "#f5f5f5", textColor: "#6b7280" },
};
